import React from "react";
import "./EmptyTabContainer.scss";

function EmptyTabContainer(props) {
  const { children, className } = props;
  return <div className={`empty-tab-container ${className}`}>{children}</div>;
}

export { EmptyTabContainer };
